import React from "react"
import numeral from "numeral"

class IncidentalDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.row.incidental_amount) {
      var incidental = this.formatCurrency(this.props.row.incidental_amount)
    } else if (this.props.row.incidental_nights) {
      var incidental = `${this.props.row.incidental_nights} ${I18n.t('nights')}`
    } else if (this.props.row.incidental_percentage) {
      var incidental = this.formatPercentage(this.props.row.incidental_percentage)
    } else {
      var incidental = <span className="none">{I18n.t('none')}</span>
    }

    return(
      <div>
        {incidental}
      </div>
    )
  }

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  }

  formatPercentage(num) {
    return parseFloat((num * 100).toFixed(2)) + "%"
  }
}

export default IncidentalDataType